module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.styles.tableStyle)
  }, _vm._l((_vm.displayData), function(record, key) {
    return _c('tr', {
      style: (_vm.styles.trStyle)
    }, [(record && record.arrow_for_close) ? _c('td', {
      staticClass: "relative text-center"
    }, [_c('span', [_vm._v(_vm._s(record.value))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times",
      style: ({
        'float': 'right',
        'margin-right': '0.5rem',
        'cursor': 'pointer'
      }),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(record)
        }
      }
    })]) : (record && (record.isEditable && _vm.displayData.selfOffer) || (record.editable && record.clickAway)) ? _c('td', {
      staticClass: "relative text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.value),
        expression: "record.value"
      }],
      style: (_vm.styles.editBoxWidthFull),
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (record.value)
      },
      on: {
        "blur": function($event) {
          $event.stopPropagation();
          _vm.editRecord(record, _vm.displayData.itemId)
        },
        "keyup": function($event) {
          if (_vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.stopPropagation();
          _vm.editRecord(record, _vm.displayData.itemId)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          record.value = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-pencil edit-marker"
    })]) : (record && record.editable) ? _c('td', {
      staticClass: "relative text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.value),
        expression: "record.value"
      }],
      style: (_vm.styles.editBoxWidthFull),
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (record.value)
      },
      on: {
        "keyup": function($event) {
          _vm.processData(record)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          record.value = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-pencil edit-marker"
    })]) : ((record && record.hasOwnProperty('makeLink') && record.makeLink) && record.hasOwnProperty('type') && record.type) ? _c('td', {
      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle),
      on: {
        "click": function($event) {
          _vm.processRecord(record)
        }
      }
    }, [_c('a', {
      style: (_vm.styles.aActualStyle)
    }, [_vm._v(_vm._s(record.value))])]) : (record && record.hasOwnProperty('makeLink') && record.makeLink) ? _c('td', {
      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle),
      on: {
        "click": function($event) {
          _vm.processRecord(record)
        }
      }
    }, [_c('div', {
      staticClass: "relative",
      on: {
        "mouseover": function($event) {
          _vm.showPopOver(key)
        },
        "mouseout": function($event) {
          _vm.hidePopOver(key)
        }
      }
    }, [_c('div', {
      class: {
        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
      }
    }, [_vm._v("\n          " + _vm._s(record.value) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "null-height"
    }, [_c('a', {
      style: (_vm.styles.aStyle)
    }, [_vm._v(_vm._s(_vm.addDotsToData(record.value)))])])])]) : (_vm.pendingOrPast === 'PAST') ? _c('td', {
      style: (_vm.styles.actualStyle)
    }, [_vm._v("\n      " + _vm._s((record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : " ") + "\n    ")]) : (_vm.pendingOrPast === 'PENDING') ? _c('td', {
      style: (_vm.styles.estimatedStyle)
    }, [_vm._v("\n      " + _vm._s((record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : " ") + "\n    ")]) : _c('td', {
      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle)
    }, [(record && record.length > 40) ? [_c('div', [_c('div', {
      staticClass: "relative",
      on: {
        "mouseover": function($event) {
          _vm.showPopOver(key)
        },
        "mouseout": function($event) {
          _vm.hidePopOver(key)
        }
      }
    }, [_c('div', {
      class: {
        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
      }
    }, [_vm._v("\n              " + _vm._s(record) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "null-height"
    }, [_vm._v("\n              " + _vm._s(_vm.addDotsToData(record)) + "\n            ")])])])] : (record && record.value && record.value.length > 40) ? [_c('div', {
      staticClass: "relative",
      on: {
        "mouseover": function($event) {
          _vm.showPopOver(key)
        },
        "mouseout": function($event) {
          _vm.hidePopOver(key)
        }
      }
    }, [_c('div', {
      class: {
        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
      }
    }, [_vm._v("\n            " + _vm._s(record.value) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "null-height"
    }, [_vm._v("\n            " + _vm._s(_vm.addDotsToData(record.value)) + "\n          ")])])] : [_vm._l((_vm.getCellRecord(record)), function(value) {
      return [_c('span', {
        class: {
          'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
        }
      }, [_vm._v("\n            " + _vm._s(value) + "\n          ")])]
    })]], 2)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38f12196!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/flexTables/DataTable.vue
// module id = 361
// module chunks = 2